<div class="form-group">
    <label class="input-label">Style:</label>
    <select class="form-control"
            name="style"
            [(ngModel)]="fieldOptions.customClass">
    <option value="">None</option>
    <option *ngFor="let style of styles" (ngModelChange)="dataChangedEvent($event)">{{style}}</option>
  </select>
</div>